module.exports = __webpack_public_path__ + "img/CAKE_icon.5ccf9cda.png";